// extracted by mini-css-extract-plugin
export default {"header-container":"mAZF70It--SiteHeader_header-container__6jQ54","headerContainer":"mAZF70It--SiteHeader_header-container__6jQ54"};